export default __webpack_public_path__ + "static/media/kadc.e31715bd.png";